<template>
    <div>
        <Dropdown>
            <Button v-bind="$attrs" type="default">
                {{$t('erp.b2corder.search_query_collect', { defaultValue: '查询收藏' })}}
                <Icon type="ios-arrow-down"></Icon>
            </Button>
            <DropdownMenu class="search-collect" slot="list">
                <DropdownItem v-if="!collectList.length">
                    <div class="search-collect-item">
                        <div class="search-collect-name">{{$t('global.common.nodata', { defaultValue: '暂无数据...' })}}</div>
                    </div>
                </DropdownItem>
                <DropdownItem v-for="item in collectList" :key="item.id">
                    <div class="search-collect-item">
                        <span class="search-collect-name" @click="handleClickCollect(item)">
                            <Tooltip max-width="250" :content="item.searchName">
                                <span class="search-collect-name-text">{{item.searchName}}</span>
                            </Tooltip>
                        </span>
                        <Icon class="search-collect-close-icon" style="color: #666;" @click="handleDeleteCollect(item)" type="md-close" />
                    </div>
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>
    </div>
</template>

<script>
export default {
    props: ['dataList', 'searchData'],
    watch: {
        dataList: {
            immediate: true,
            handler (list) {
                this.collectList = list;
            }
        },
    },
    data () {
        return {
            collectList: []
        }
    },
    methods: {
        // 选中
        handleClickCollect (item) {
            this.$emit('on-click-item', item);
        },
        // 删除
        handleDeleteCollect (item) {
            this.$emit('on-delete-item', item);
        }
    }
}
</script>

<style lang="scss" scoped>
.search-collect {
    max-width: 150px;
    .ivu-dropdown-item {
        padding: 0;
    }
    .search-collect-item {
        padding-right: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .search-collect-name {
        padding: 7px 0 7px 16px;
        flex: 1;

        .search-collect-name-text {
            display: block;
            max-width: 100px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-break: break-all;
        }
    }
    .search-collect-close-icon {
        color: #666666;
        opacity: .66;
        &:hover {
            opacity: 1;
        }
    }
}
</style>